<template>
    <div>
        <div class="mb-4 d-flex align-items-center justify-content-end">
            <button type="button"
                    class="btn btn-success"
                    :class="{
                        'disabled': state.loading || state.refreshing
                    }"
                    :disabled="state.loading || state.refreshing"
                    @click="refresh">
                <i class="fas fa-sync mr-1" v-if="!state.refreshing"></i>
                <i class="fas fa-spinner fa-spin mr-1" v-if="state.refreshing"></i>
                <span v-if="!state.refreshing">Refresh</span>
                <span v-if="state.refreshing">Refreshing</span>
            </button>
        </div>

        <spinner v-if="state.loading"/>

        <div class="table-responsive">
            <table class="table table-middle" v-if="system">
                <tbody>
                    <tr>
                        <td class="pl-0 text-left" style="width: 200px;">CPU</td>
                        <td class="pr-0 text-right" v-if="system.cpu">
                            <div class="text-right">{{ system.cpu.load }}%</div>
                            <div class="progress">
                                <div class="progress-bar"
                                     :class="{
                                    'bg-warning': system.cpu.status === 'warning',
                                    'bg-danger': system.cpu.status === 'danger',
                                 }"
                                     role="progressbar"
                                     :style="{ 'width': system.cpu.load + '%'}"
                                     :aria-valuenow="system.cpu.load"
                                     aria-valuemin="0"
                                     aria-valuemax="100">{{ system.cpu.load }}%
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="pl-0 text-left" style="width: 200px;">Memory</td>
                        <td class="pr-0 text-right" v-if="system.memory">
                            <div class="text-right">
                                {{ system.memory.used }} /
                                {{ system.memory.total }}
                            </div>
                            <div class="progress">
                                <div class="progress-bar"
                                     :class="{
                                    'bg-warning': system.memory.status === 'warning',
                                    'bg-danger': system.memory.status === 'danger',
                                 }"
                                     role="progressbar"
                                     :style="{ 'width': system.memory.used_percentage + '%'}"
                                     :aria-valuenow="system.memory.used_percentage"
                                     aria-valuemin="0"
                                     aria-valuemax="100">{{ system.memory.used_percentage }}%
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="pl-0 text-left" style="width: 200px;">Disk</td>
                        <td class="pr-0 text-right" v-if="system.disk">
                            <div class="text-right">
                                {{ system.disk.used }} /
                                {{ system.disk.total }}
                            </div>
                            <div class="progress">
                                <div class="progress-bar"
                                     :class="{
                                    'bg-warning': system.disk.status === 'warning',
                                    'bg-danger': system.disk.status === 'danger',
                                 }"
                                     role="progressbar"
                                     :style="{ 'width': system.disk.used_percentage + '%'}"
                                     :aria-valuenow="system.disk.used_percentage"
                                     aria-valuemin="0"
                                     aria-valuemax="100">{{ system.disk.used_percentage }}%
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="pl-0 text-left" style="width: 200px;">Campaign Service</td>
                        <td class="pr-0 text-right">
                            <badge variant="success" v-if="system.service === 'active'">active</badge>
                            <badge variant="danger" v-if="system.service === 'inactive'">inactive</badge>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            system: null,
            state: {
                loading: false,
                refreshing: false
            }
        };
    },

    methods: {
        fetch() {
            return axios.get('/api/system').then(response => {
                this.system = response.data;
                this.state.loading = false;
                this.state.refreshing = false;
            }).catch(() => {
                this.state.loading = false;
                this.state.refreshing = false;
            });
        },
        refresh() {
            this.state.refreshing = true;
            this.fetch();
        }
    },

    mounted() {
        this.state.loading = true;
        this.fetch();

        this.timer = setInterval(() => {
            this.fetch();
        }, 5000);
    }
}
</script>
